const style = {
  modalWrapper: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 10,
  },
  backdropFilter: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    // maxWidth: 700,
    // width: '100%',
    backgroundColor: '#fff',
    zIndex: 1,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    padding: '50px 75px 30px',
    borderRadius: '4px',
  },
  header: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    fontSize: '26px',
    alignSelf: 'center',
    marginBottom: 36,
  },
  body: {
    fontSize: '16px',
    marginBottom: 20,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    padding: '10px 30px',
    fontSize: 16,
    color: '#646464',
    fontWeight: 'bold',
    '&:not(:last-child)': { marginRight: 20 },
  },
  cross: {
    cursor: 'pointer',
    position: 'absolute',
    top: 10,
    right: 10,
  },
  back: {
    cursor: 'pointer',
    position: 'absolute',
    top: 10,
    left: 10,
  },
}

export default style
